import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_CHECKLIST,
  ADD_CHECKLIST,
  UPDATE_CHECKLIST,
  DELETE_CHECKLIST,
} from './actionTypes'
import {
  getCheckListSuccess,
  getCheckListFail,
  addCheckListSuccess,
  addCheckListFail,
  updateCheckListSuccess,
  updateCheckListFail,
  deleteCheckListSuccess,
  deleteCheckListFail,
  setCheckListFieldErrors,
  getCheckList,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchCheckListApi = (id) => axiosInstance.get('', { params: { sp: 'usp_GetChecklists', catalogueId: id } })
const addCheckListApi = (checklist) => axiosInstance.post('', checklist)
const updateCheckListApi = (checklist) => axiosInstance.post('', checklist)
const deleteCheckListApi = (id) => axiosInstance.post('', { sp: 'usp_DeleteChecklist', checklistId: id })

// Sagas
function* getCheckListSaga(action) {
  try {
    const { data } = yield call(fetchCheckListApi, action.payload)
    yield put(getCheckListSuccess(data))
  } catch (error) {
    yield put(getCheckListFail(error.response?.data || error.message))
  }
}

function* addCheckListSaga(action) {
  try {
    const { data } = yield call(addCheckListApi, action.payload)
    yield put(addCheckListSuccess(data))
    toast.success('Checklist item added successfully!')
    yield put(getCheckList(action.payload.catalogueId))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setCheckListFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addCheckListFail(error.response?.data || error.message))
    }
  }
}

function* updateCheckListSaga(action) {
  try {
    const { data } = yield call(updateCheckListApi, action.payload)
    yield put(updateCheckListSuccess(data))
    toast.success('Checklist item updated successfully!')
    yield put(getCheckList(action.payload.catalogueId))
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setCheckListFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateCheckListFail(error.response?.data || error.message))
    }
  }
}

function* deleteCheckListSaga(action) {
  try {
    yield call(deleteCheckListApi, action.payload?.id)
    yield put(deleteCheckListSuccess(action.payload))
    toast.success("Checklist item deleted successfully!")
    yield put(getCheckList(action.payload?.catalogueId))
  } catch (error) {
    yield put(deleteCheckListFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* checklistSaga() {
  yield takeEvery(GET_CHECKLIST, getCheckListSaga)
  yield takeEvery(ADD_CHECKLIST, addCheckListSaga)
  yield takeEvery(UPDATE_CHECKLIST, updateCheckListSaga)
  yield takeEvery(DELETE_CHECKLIST, deleteCheckListSaga)
}

export default checklistSaga
